import dashboard from "./dashboard";
import admin from "./admin";
import pinner from "./pinner";

export default {
    // pinner,
    dashboard,
//   admin,
};